import useDarkMode from "../../../hooks/useDarkMode.js";
import useThemeColor from "../../../hooks/useThemeColor.js";
import "./customModal.css";

const CustomModal = ({
  isOpen,
  onClose,
  title,
  subtitle,
  onSubmit,
  showButton,
  showSubmitButton = true,
  showCancelButton = true,
  fontSize = "18px",
  fontWeight = "700",
  subtitleFontSize = "14px",
  subtitleFontWeight = "400",
  children,
  modalSize = "",
  minHeight = "200px",
  maxHeight = "550px",
  isCentered = false,
  submitButtonText = "Save",
  submitButtonDisabled = false,
  zIndex = 9999,
  closeOnBackdropClick = false,
}) => {
  const isDarkMode = useDarkMode();
  const themeColor = useThemeColor();

  if (!isOpen) return null;

  const themeClass = isDarkMode ? "is-dark" : "is-light";

  return (
    <div
      className="modal fade show d-block custom-modal-backdrop"
      style={{ zIndex }}
      role="dialog"
      aria-modal="true"
      onClick={closeOnBackdropClick ? onClose : undefined}
    >
      <div
        className={`modal-dialog custom-modal-dialog ${modalSize} ${isCentered ? "is-centered" : ""}`}
        style={{ zIndex: zIndex + 1 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={`modal-content custom-modal-content ${themeClass}`}
          style={{
            minHeight,
            maxHeight,
            zIndex: zIndex + 2,
          }}
        >
          <div className="custom-modal-header">
            <div className="custom-modal-header-main">
              <span
                className="custom-modal-accent"
                style={{
                  background: `linear-gradient(180deg, ${themeColor} 0%, ${themeColor}cc 100%)`,
                }}
              />
              <div className="custom-modal-title-wrap">
                <h5
                  className="custom-modal-title"
                  style={{ fontSize, fontWeight }}
                >
                  {title}
                </h5>
                {subtitle && (
                  <p
                    className="custom-modal-subtitle"
                    style={{
                      fontSize: subtitleFontSize,
                      fontWeight: subtitleFontWeight,
                    }}
                  >
                    {subtitle}
                  </p>
                )}
              </div>
            </div>
            <button
              type="button"
              className="custom-modal-close"
              onClick={onClose}
              aria-label="Close"
            >
              <i className="fa fa-times" />
            </button>
          </div>

          <div className="custom-modal-body">{children}</div>

          {showButton && (
            <div className="custom-modal-footer">
              {showCancelButton && (
                <button
                  onClick={onClose}
                  type="button"
                  className="custom-modal-btn custom-modal-btn-cancel"
                >
                  Cancel
                </button>
              )}

              {showSubmitButton && (
                <button
                  onClick={onSubmit}
                  type="button"
                  className="custom-modal-btn custom-modal-btn-submit"
                  disabled={submitButtonDisabled}
                  style={{
                    background: submitButtonDisabled
                      ? undefined
                      : `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`,
                  }}
                >
                  {submitButtonText}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomModal;
